/**
 * Parse stored aiSummary — JSON object or legacy plain text
 */
export const parseAiSummary = (raw) => {
  if (!raw) return null;
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (parsed?.summary) return parsed;
  } catch {
    // legacy plain string
  }
  return {
    summary: String(raw),
    recommendation: '',
    confidence: '',
    risks: [],
  };
};

const RECOMMENDATION_LABELS = {
  apply: 'Uygula',
  reject: 'Reddet',
  retest: 'Tekrar Test',
  monitor: 'İzlemeye Devam',
  pending: 'Beklemede',
};

export const getRecommendationLabel = (value) =>
  RECOMMENDATION_LABELS[value] || value || '—';

/** Build API payload from report document for AI summary generation */
export const buildAICommentPayload = (report, metricIndex = 0) => {
  const analysis = report.analysis?.[metricIndex] || report.analysis?.[0];
  if (!analysis) return null;

  return {
    reportId: report._id,
    reportName: report.reportName,
    dateRange: report.dateRange,
    formattedStartDate: report.formattedStartDate,
    formattedEndDate: report.formattedEndDate,
    testDuration: report.testDuration,
    resultStatus: analysis.resultStatus,
    sessionTab: analysis.control?.tabName || 'Sessions',
    conversionTab: analysis.name || 'Transactions',
    analysis,
  };
};
